import { render } from "./Exhibitions.vue?vue&type=template&id=b0ab8be4"
import script from "./Exhibitions.vue?vue&type=script&lang=js"
export * from "./Exhibitions.vue?vue&type=script&lang=js"

import "./Exhibitions.vue?vue&type=style&index=0&id=b0ab8be4&lang=scss"

import exportComponent from "/tmp/build_cd2b88ef/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__